import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, Row, Select, Spin } from "antd";
import { toastError } from "../../../helpers/toasters";
import { getTermsAndConditions, signUpApi } from "../../../network";
import { ROUTES } from "../../../constants/_routes";

// assets
import logoIcon from "../../../assets/images/logo.png";
import egFlag from "../../../assets/icons/egypt-flag.svg";
import aeFlag from "../../../assets/icons/emirates-flag.svg";

// components
import GlobalModal from "../GlobalModal";
import LanguageBtn from "../../Common/LanguageBtn/LanguageBtn";
import TermAndConditionsModal from "./TermsAndConditionsModal";

const nameRegex = /^[A-Za-z\u0621-\u064A]+$/;

function SignUp() {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [termsError, setTermsError] = useState(false);
  const [nameError, setNameError] = useState("");
  const [terms, setTerms] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [idNumberError, setIdNumberError] = useState("");
  const { authorization } = useSelector((state) => state?.auth);
  const { dir } = useSelector((state) => state.language);
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState("eg");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");

  const [firstNameError, setFirstNameError] = useState("");
  const [middleNameError, setMiddleNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");

  useEffect(() => {
    if (authorization.token) {
      if (authorization?.isEmirate) {
        navigate("/buy-and-supply/buy", { replace: true });
      } else {
        navigate("/home", { replace: true });
      }
    } else {
      setIsAuthenticated(false);
    }
  }, [authorization]);

  useEffect(() => {
    getTermsAndConditions(
      (success) => {
        if (success.success) {
          setTerms(success.data);
        } else {
          toastError(success.message);
        }
      },
      (fail) => {
        toastError(fail?.data?.error);
      }
    );
  }, [dir]);

  // const handleOnChangeName = (e) => {
  //   const value = e.target.value;
  //   setFullName(value);
  //   if (!value) {
  //     setNameError("requiredName");
  //   } else if (/^[A-Za-z\s\u0621-\u064A]*$/.test(value)) {
  //     setNameError("");
  //   } else {
  //     setNameError("invalidName");
  //   }
  // };

  const handleFirstNameChange = (e) => {
    const value = e.target.value;
    setFirstName(value);
    if (!value) setFirstNameError("requiredFirstName");
    else if (!nameRegex.test(value) || value.length < 3)
      setFirstNameError("invalidName");
    else setFirstNameError("");
  };

  const handleMiddleNameChange = (e) => {
    const value = e.target.value;
    setMiddleName(value);
    if (!value) setMiddleNameError("requiredSecondName");
    else if (!nameRegex.test(value) || value.length < 3)
      setMiddleNameError("invalidName");
    else setMiddleNameError("");
  };

  const handleLastNameChange = (e) => {
    const value = e.target.value;
    setLastName(value);
    if (!value) setLastNameError("requiredThirdName");
    else if (!nameRegex.test(value) || value.length < 3)
      setLastNameError("invalidName");
    else setLastNameError("");
  };

  // phone handler
  const handleOnChangePhone = (e) => {
    if (selectedCountry === "eg") {
      const phoneRegex = /^[\d]*$/;
      if (phoneRegex.test(e.target.value)) {
        setMobile(e.target.value);
        setPhoneError("");
      } else {
        return;
      }
      if (e.target.value.length === 0) {
        setPhoneError("requiredMobile");
      } else {
        let phoneLen = 11;
        let charLen = 2;
        if (!e.target.value.startsWith("0")) {
          phoneLen = 10;
          charLen = 1;
        }
        if (
          e.target.value.length > phoneLen ||
          (e.target.value.length >= charLen &&
            !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}1`)) ||
          (e.target.value.length >= charLen + 1 &&
            !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}10`) &&
            !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}11`) &&
            !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}12`) &&
            !e.target.value.startsWith(`${charLen === 2 ? "0" : ""}15`))
        ) {
          setPhoneError("invalidMobile");
        }
      }
    } else if (selectedCountry === "ae") {
      const phoneRegex = /^[\d]*$/;
      if (phoneRegex.test(e.target.value)) {
        setMobile(e.target.value);
        setPhoneError("");
      } else {
        return;
      }

      if (e.target.value.length === 0) {
        setPhoneError("requiredMobile");
      } else {
        const validPrefixes = ["50", "52", "54", "55", "56", "58"];
        const prefix = e.target.value.substring(0, 2);

        if (
          e.target.value.length > 9 ||
          (e.target.value.length >= 2 && !validPrefixes.includes(prefix))
        ) {
          setPhoneError("invalidMobile");
        }
      }
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailError(false);
    if (!value) {
      setEmailError("requiredEmail");
    } else if (!/^[A-Za-z0-9+_.-]+@(.+)$/.test(value)) {
      setEmailError("invalidEmail");
    } else {
      setEmailError("");
    }
  };

  // const isValidEgyptianId = (id) => {
  //   // Check if ID is exactly 14 digits
  //   if (!/^\d{14}$/.test(id)) return false;

  //   // Check century digit
  //   const century = id[0];
  //   if (century !== "2" && century !== "3") return false;

  //   // Extract and validate date components
  //   const year = parseInt((century === "2" ? "19" : "20") + id.slice(1, 3), 10);
  //   const month = parseInt(id.slice(3, 5), 10);
  //   const day = parseInt(id.slice(5, 7), 10);

  //   // Basic range validation
  //   if (month < 1 || month > 12 || day < 1 || day > 31) return false;

  //   // More robust date validation
  //   const date = new Date(year, month - 1, day); // month is 0-indexed in Date constructor
  //   if (
  //     date.getFullYear() !== year ||
  //     date.getMonth() !== month - 1 ||
  //     date.getDate() !== day
  //   ) {
  //     return false; // invalid date
  //   }

  //   // Validate governorate codes
  //   const validGovernorates = [
  //     "01",
  //     "02",
  //     "03",
  //     "04",
  //     "11",
  //     "12",
  //     "13",
  //     "14",
  //     "15",
  //     "16",
  //     "17",
  //     "18",
  //     "19",
  //     "21",
  //     "22",
  //     "23",
  //     "24",
  //     "25",
  //     "26",
  //     "27",
  //     "28",
  //     "29",
  //     "31",
  //     "32",
  //     "33",
  //     "34",
  //     "35",
  //     "88",
  //   ];
  //   const governorate = id.slice(7, 9);
  //   if (!validGovernorates.includes(governorate)) return false;

  //   return true;
  // };

  const handleIdNumberChange = (e) => {
    const value = e.target.value;
    // allow only numbers
    if (!/^\d*$/.test(value)) return;

    setIdNumber(value);

    if (!value) {
      setIdNumberError("requiredIdNumber");
    } else if (
      // value.length > 15 ||
      // value.length < 14
      // !(value.startsWith("2") || value.startsWith("3"))
      value.length !== 14 &&
      value.length !== 15
    ) {
      setIdNumberError("invalidIdNumber");
    } else {
      setIdNumberError("");
    }
  };

  const onCancel = () => {
    setIsModalOpen(false);
  };

  const onAction = (data) => {};

  const handleTermsConditions = (e) => {
    if (e.target.checked && termsError) {
      setTermsError(false);
    }
    setIsTermsAccepted(e.target.checked);
  };

  const onFinish = (e) => {
    e.preventDefault();
    if (!firstName) setFirstNameError("requiredFirstName");
    if (!middleName) setMiddleNameError("requiredSecondName");
    if (!lastName) setLastNameError("requiredThirdName");
    // if (!mobile) {
    //   setPhoneError("requiredMobile");
    // } else if (mobile.length > 11 || mobile.length < 10) {
    //   setPhoneError("invalidMobile");
    // }
    if (!mobile) {
      setPhoneError("requiredMobile");
    } else if (
      selectedCountry === "eg" &&
      (mobile.length > 11 || mobile.length < 10)
    ) {
      setPhoneError("invalidMobile");
    } else if (selectedCountry === "ae" && mobile.length !== 9) {
      setPhoneError("invalidMobile");
    }

    if (!isTermsAccepted) {
      setTermsError(true);
    }

    if (!email) {
      setEmailError("requiredEmail");
    }

    if (selectedCountry === "eg") {
      if (!idNumber) {
        setIdNumberError("requiredIdNumber");
      } else if (idNumber.length !== 14 && idNumber.length !== 15) {
        setIdNumberError("invalidIdNumber");
      }
    }

    // if (
    //   firstName &&
    //   middleName &&
    //   lastName &&
    //   mobile &&
    //   // (mobile.length === 10 || mobile.length === 11) &&
    //   ((selectedCountry === "eg" &&
    //     (mobile.length === 10 || mobile.length === 11)) ||
    //     (selectedCountry === "ae" && mobile.length === 9)) &&
    //   // idNumber &&
    //   // (idNumber.length === 14 || idNumber.length === 15) &&

    //   (selectedCountry === "ae" ||
    //     (idNumber && (idNumber.length === 14 || idNumber.length === 15))) &&
    //   isTermsAccepted &&
    //   !emailError &&
    //   // !nameError &&
    //   !firstNameError &&
    //   !middleNameError &&
    //   !lastNameError &&
    //   !phoneError &&
    //   (selectedCountry === "ae" || !idNumberError)
    // ) {
    if (
      firstName &&
      middleName &&
      lastName &&
      mobile &&
      ((selectedCountry === "eg" &&
        (mobile.length === 10 || mobile.length === 11)) ||
        (selectedCountry === "ae" && mobile.length === 9)) &&
      (selectedCountry === "ae" ||
        (idNumber && (idNumber.length === 14 || idNumber.length === 15))) &&
      isTermsAccepted &&
      !emailError &&
      !firstNameError &&
      !middleNameError &&
      !lastNameError &&
      !phoneError &&
      (selectedCountry === "ae" || !idNumberError)
    ) {
      setLoading(true);
      const data = {
        // fullName: fullName.trim().split(/\s+/).join(" "),
        fullName: `${firstName.trim()} ${middleName.trim()} ${lastName.trim()}`,
        email,
        // mobile: `2${mobile.length === 10 ? "0" : ""}${mobile}`,
        mobile:
          selectedCountry === "eg"
            ? `2${mobile.length === 10 ? "0" : ""}${mobile}`
            : `971${mobile}`,
      };

      if (selectedCountry === "eg") {
        data.idNumber = idNumber;
      }

      signUpApi(
        data,
        (success) => {
          setLoading(false);
          if (success?.success) {
            setIsModalOpen(true);
          } else {
            toastError(success.message);
          }
        },
        (fail) => {
          setLoading(false);
          toastError(fail?.data?.error);
        }
      );
    }
  };

  return !isAuthenticated ? (
    <section className="mct-section mct-section-signin d-flex flex-column justify-content-center align-items-center">
      <div className="w-100 fixed-top d-flex align-items-center justify-content-between py-3 px-4">
        <div className="logo">
          <img className="icon" src={logoIcon} alt="logo" />
        </div>
        <LanguageBtn inNavbar={false} />
      </div>
      <div className="contact-us__content">
        <Row justify={"center"} className="wd-100">
          <form onSubmit={onFinish} className="contact-us__form wd-100">
            <h1 className="text-center fsize-8 green-text w-100 mb-4">
              {t("auth.signup")}
            </h1>
            {/* <div dir={dir} className="contact-us__form-field">
              <label className="fsize-9">{t("auth.name")}</label>
              <input
                type={"text"}
                name="name"
                value={fullName}
                onChange={handleOnChangeName}
                className={`contact-us__form-input outline-0 fsize-8 ${
                  nameError ? "border border-1 border-danger" : "border-0"
                } `}
              />
              {nameError && (
                <span className="contact-us__field-error fsize-10 mt-1">
                  {t(`auth.${nameError}`)}
                </span>
              )}
            </div> */}

            <div
              dir={dir}
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              <div dir={dir} className="">
                <label className="fsize-9">{t("auth.firstName")}</label>
                <input
                  type="text"
                  value={firstName}
                  onChange={handleFirstNameChange}
                  // placeholder={t("auth.firstName")}
                  className={`contact-us__form-input outline-0 fsize-8 ${
                    firstNameError
                      ? "border border-1 border-danger"
                      : "border-0"
                  }`}
                />
                {firstNameError && (
                  <span className="contact-us__field-error fsize-10 mt-1">
                    {t(`auth.${firstNameError}`)}
                  </span>
                )}
              </div>

              <div dir={dir} className="">
                <label className="fsize-9">{t("auth.middleName")}</label>
                <input
                  type="text"
                  value={middleName}
                  onChange={handleMiddleNameChange}
                  className={`contact-us__form-input outline-0 fsize-8 ${
                    middleNameError
                      ? "border border-1 border-danger"
                      : "border-0"
                  }`}
                />
                {middleNameError && (
                  <span className="contact-us__field-error fsize-10 mt-1">
                    {t(`auth.${middleNameError}`)}
                  </span>
                )}
              </div>
            </div>

            <div dir={dir} className="contact-us__form-field">
              <label className="fsize-9">{t("auth.lastName")}</label>
              <input
                type="text"
                value={lastName}
                onChange={handleLastNameChange}
                className={`contact-us__form-input outline-0 fsize-8 ${
                  lastNameError ? "border border-1 border-danger" : "border-0"
                }`}
              />
              {lastNameError && (
                <span className="contact-us__field-error fsize-10 mt-1">
                  {t(`auth.${lastNameError}`)}
                </span>
              )}
            </div>

            {/* <div dir={dir} className="contact-us__form-field my-3">
              <label className="fsize-9">{t("auth.phone")}</label>
              <div
                className={`${
                  dir === "rtl" ? "ps-0" : "pe-0"
                } py-0 d-flex align-items-center gap-1 gap-sm-2 contact-us__form-input ${
                  phoneError ? "border border-1 border-danger" : "border-0"
                }`}
              >
                <div className="d-flex align-items-center gap-1">
                  <div>
                    <img src={flag} alt="" className="d-block img-fluid" />
                  </div>
                  <div className="contact-us__country-code flex-fill">
                    <span className="fsize-9">+20</span>
                  </div>
                </div>
                <div className="flex-fill">
                  <input
                    type={"text"}
                    name="phone"
                    value={mobile}
                    onChange={handleOnChangePhone}
                    className={`contact-us__form-input ps-2 outline-0 fsize-8 border-0`}
                  />
                </div>
              </div>
              {phoneError && (
                <span className="contact-us__field-error fsize-10 mt-1">
                  {t(`auth.${phoneError}`)}
                </span>
              )}
            </div> */}

            <div dir={dir} className="contact-us__form-field my-3">
              <label className="fsize-9">{t("auth.phone")}</label>
              <div
                className={`${
                  dir === "rtl" ? "ps-0" : "pe-0"
                } py-0 d-flex align-items-center gap-1 contact-us__form-input ${
                  phoneError ? "border border-1 border-danger" : "border-0"
                }`}
              >
                <Select
                  className="form-phone"
                  value={selectedCountry}
                  onChange={(v) => {
                    setSelectedCountry(v);
                    setPhoneError(null);
                    setMobile("");

                    if (v === "ae") {
                      setIdNumber("");
                      setIdNumberError("");
                    }
                  }}
                  options={[
                    {
                      label: (
                        <div className="d-flex align-items-center gap-2">
                          <img src={egFlag} alt="egypt flag" width="20" />
                          <span>+20</span>
                        </div>
                      ),
                      value: "eg",
                    },
                    {
                      label: (
                        <div className="d-flex align-items-center gap-2">
                          <img src={aeFlag} alt="egypt flag" width="20" />
                          <span>+971</span>
                        </div>
                      ),
                      value: "ae",
                    },
                  ]}
                />

                <div className="flex-fill">
                  <input
                    type="text"
                    name="phone"
                    value={mobile}
                    onChange={handleOnChangePhone}
                    className="contact-us__form-input ps-2 outline-0 fsize-8 border-0"
                    // placeholder={
                    //   selectedCountry === "eg"
                    //     ? "Eg: 10xxxxxxxx"
                    //     : "UAE: 50xxxxxxx"
                    // }
                  />
                </div>
              </div>

              {phoneError && (
                <span className="contact-us__field-error fsize-10 mt-1">
                  {t(`auth.${phoneError}`)}
                </span>
              )}
            </div>

            <div dir={dir} className="contact-us__form-field mb-3">
              <label className="fsize-9">{t("auth.email")}</label>
              <input
                type={"text"}
                name="email"
                value={email}
                onChange={handleEmailChange}
                className={`contact-us__form-input fsize-8 outline-0 ${
                  emailError ? "border border-1 border-danger" : "border-0"
                } `}
              />
              {emailError && (
                <span className="contact-us__field-error fsize-10">
                  {t(`auth.${emailError}`)}
                </span>
              )}
            </div>

            {selectedCountry === "eg" && (
              <div dir={dir} className="contact-us__form-field mb-3">
                <label className="fsize-9">{t("auth.idNumber")}</label>
                <input
                  type="text"
                  name="idNumber"
                  value={idNumber}
                  onChange={handleIdNumberChange}
                  maxLength={15}
                  className={`contact-us__form-input fsize-8 outline-0 ${
                    idNumberError ? "border border-1 border-danger" : "border-0"
                  }`}
                />
                {idNumberError && (
                  <span className="contact-us__field-error fsize-10">
                    {t(`auth.${idNumberError}`)}
                  </span>
                )}
              </div>
            )}

            <div
              dir={dir}
              className={`w-100 d-flex align-items-center gap-2 my-2`}
            >
              <input
                type="checkbox"
                name="terms-and-conditions"
                id="terms-checkbox"
                className={`${termsError ? "error" : ""} auth-checkbox`}
                checked={isTermsAccepted}
                onChange={handleTermsConditions}
              />
              <label className="fsize-10">
                {t("auth.accept")}{" "}
                <span
                  onClick={() => setIsTermsModalOpen(true)}
                  className="terms-text text-underline"
                >
                  {t("auth.termsAndConditions")}
                </span>
              </label>
            </div>
            <div className="sign-in-btns mt-2 mt-md-4 d-flex gap-3 flex-column justify-content-between align-items-center w-100">
              <Button
                loading={loading}
                className="sign-in-btn border-0 fsize-9 h-auto"
                htmlType="submit"
              >
                {t("auth.signup")}
              </Button>
              <div className="sign-up-btn fsize-9">
                <span className="white-text">{t("auth.withAccount")} </span>
                <Link
                  to={ROUTES.SIGNIN}
                  className="fw-semibold green-text h-auto"
                >
                  {t("auth.login")}
                </Link>
              </div>
            </div>
          </form>
        </Row>
        {isModalOpen && (
          <GlobalModal
            name="otp-modal"
            isModalOpen={isModalOpen}
            onCancel={onCancel}
            onAction={onAction}
            data={{
              // mobile: `2${mobile.length === 10 ? "0" : ""}${mobile}`,
              selectedCountry,
              mobile:
                selectedCountry === "eg"
                  ? `2${mobile.length === 10 ? "0" : ""}${mobile}`
                  : `971${mobile}`,
              fireBaseToken: "fireBaseToken",
              deviceId: "deviceId",
            }}
          />
        )}
        {isTermsModalOpen && (
          <TermAndConditionsModal
            isOpen={isTermsModalOpen}
            data={terms}
            onCancel={() => setIsTermsModalOpen(false)}
          />
        )}
      </div>
    </section>
  ) : (
    <div>
      <Spin
        size="large"
        className="spin-overlay w-100 h-100 position-absolute top-0 start-0 d-flex justify-content-center align-items-center"
      ></Spin>
    </div>
  );
}

export default SignUp;
